<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-row :gutter="10" class="mb8">              
                <el-col :span="12">
                    <el-form-item label="标题：" prop="title">
                        <el-input v-model="form.title" />
                    </el-form-item>
                </el-col>   
                <el-col :span="12">
                    <el-form-item label="文档所在目录：" prop="dirId">
                        <el-select v-model="form.dirId" style="margin: 5px 10px 5px 10px;" @change="handleSelectDir">
                            <el-option 
                            v-for="dir in filteredDirs" 
                            :key="dir.id" 
                            :label="dir.name" 
                            :value="dir.id"
                            ></el-option>
                        </el-select>

                    </el-form-item>
                </el-col>          
            </el-row>                      
            <el-row :gutter="10" class="mb8">                 
                <el-col :span="24">
                    <el-form-item label="网页URL：" prop="url">
                        <el-input v-model="form.url" aria-placeholder="请输入以http://或https://开头的网址" />
                    </el-form-item>
                </el-col>      
            </el-row>
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">                
                <el-col :span="24">
                    <el-form-item  style="font-size: small;" label="请注意：" prop="name">
                        <a style="font-size: small;">1. Url应以http://或https开头；</a><br/>
                        <a style="font-size: small;">2. 请确认对应的网页可以被访问；</a><br/>
                        <a style="font-size: small;">3. 建议抓取自有网站的网页，有些互联网网页可能集成防爬虫技术，导致抓取失败。</a>><br/>
                        <a style="font-size: small;">4. 如果抓取成功，该网页的内容会同时上传至文档库和知识库【{{ workspace_name }}】。</a>
                    </el-form-item>                    
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

     <script>
     import { getDefaultFolder,is_url_existed_in_dir,
         uploadLink  }
         from"@/api/aics/KbDocument.js";

     export default {
         name: "AnythingllmUploadLink",

         props: {
            workspace_name:{
             type: String,
             default: ''                
            },
           workspace_slug: { // 新增 workspace_slug prop
             type: String,
             default: ''
           },
           tenantId: {
             type: Number,
             default: 0
           },
           username:{
             type: String,
             default: ''
           },
          dirs: {
            type: Array,
            default: () => []
          }
         },
         data() {
           return {
            defaultFolder:'',
            form: {
              title: "",
              targetFolder: "",
               url: "",
               dirId: "",
               workspaceSlug: "",
               
             },      
             rules: {
                title: [
                 { required: true, message: "请输入标题", trigger: "blur" },
               ],
                dirId: [
                 { required: true, message: "请选择文档所在目录", trigger: "blur" },
               ],
               url: [
                 { required: true, message: "请输入待抓取的URL", trigger: "blur" },
               ]
             }
           };
         },
        computed: {
            // 使用计算属性过滤数据
            filteredDirs() {
            return this.dirs.filter(dir => (dir.id != 0 || dir.name=='/'));
            }
        },         
         mounted() {
          console.log("username", this.username)
          console.log("workspace_slug", this.workspace_slug)
            getDefaultFolder(this.tenantId).then(response => {
                console.log("getDefaultFolder - 结果:", response);
                if (response.code === 200) {
                    this.defaultFolder = response.message;
                    this.form.targetFolder = this.defaultFolder;

                } else {
                    this.defaultFolder = '';
                }
                });
         },
         methods: {
           validate(callback) {
              console.log("Baseinfo validate");
                  this.$refs["form"].validate((valid) => {
                      callback(valid);
                  });
            },
            handleSelectDir(val){
              this.form.dirId = val;

            },
            async submitForm() {                
              console.log("this.form:", this.form);
              this.$refs["form"].validate(valid => {
              if (valid) {
              if(!this.form.url.toLocaleLowerCase().startsWith("http://") && !this.form.url.toLocaleLowerCase().startsWith("https://")){
                  this.$message.error("Url应以http://或https://开头");
                  return;
              }
                   is_url_existed_in_dir(this.form.url, this.form.dirId).then(res =>{
                       console.log(res);
                      if(res.data.code == 200 && res.data.data) { //res.data.data是boolean型，表示是否存在
                          this.$confirm("该网页在文档库中已存在，是否覆盖？", "提示", {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning"
                                }).then(() => {
                                  console.log("用户同意覆盖，开始上传") 
                                  this.upload();
                                }).catch(() => {
                                    console.log("用户取消覆盖"); 
                                });                              
                            } else {
                                console.log("文档不存在，开始上传") 
                                this.upload();
                            }

                        }) 
 
            }
          })
        },
        upload(){
          this.form.username = this.username;
          this.form.workspaceSlug= this.workspace_slug
          console.log("this.upload", this.form)
          uploadLink(this.form).then(res =>{
            console.log(res);
            if(res.data.code ===200){
              this.$message.success("抓取网页任务已经派发，请等待后台执行");
              this.$emit('submit-success', true);
           }
            else{
                this.$message.error("抓取网页失败,请确认URL可以访问，并且未启用防止抓取技术");
            }

          });

        }

    }
  }
    </script>

    <style scoped>
    .upload-container {
       position: relative;
       display: inline-block;
       width: 100%;
       height: 100%;
       border: 1px dashed #ccc;
       border-radius: 4px;
       background-color: #f5f5f5;
       }
       .required-asterisk{
         color: red;
         margin-left: 10px;
       }

       .file-input {
          display: none;
        }

        .upload-box {
        display: block;
        width: 100%;
        height: 120px;
        border: 2px dashed #474747;
        border-radius: 8px;
        background-color: rgba(240, 244, 249, 0.5);
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        overflow: hidden;

        &:hover {
            border-color: #00f0ff;
            background-color: rgba(#00f0ff, 0.05);
        }
    }
    .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #999;
    }

    .plus-icon {
        font-size: 2rem;
        font-weight: lighter;
        margin-bottom: 8px;
        color: #00f0ff;
    }

    .upload-text {
        font-size: 0.9rem;
    }

    .file-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
      position: relative;
      pointer-events: none;
     }

.file-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  pointer-events: auto; /* 但允许删除按钮接收点击事件 */

  &:hover {
    background: #ff7875;
  }
}
/* 上传状态样式 */
.upload-status {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.uploading-text {
  color: #1890ff;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.uploading-text i {
  margin-right: 6px;
  font-size: 16px;
}

.success-text {
  color: #52c41a;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.success-text i {
  margin-right: 6px;
  font-size: 16px;
}

.error-text {
  color: #ff4d4f;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.error-text i {
  margin-right: 6px;
  font-size: 16px;
}

/* 进度条自定义样式 */
:deep(.el-progress-bar) {
  padding-right: 0;
}

:deep(.el-progress__text) {
  font-size: 12px;
  min-width: 40px;
}
.preview-area{
    border: 2px dashed #474747;
}


</style>